import React from 'react';
import { Container, } from 'react-bootstrap';
import ContactPageBody from '../../components/ContactPageBody/ContactPageBody';

function ContactMobile(props) {
    return (
        <Container fluid style={{padding:0}}>
            <ContactPageBody/>
        </Container>
    );
}

export default ContactMobile;